import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Message} from '@aperza/ui';
import PropTypes from 'prop-types';
import style from './FormRow.module.scss';

const FormRow = (props) => {

  let {
    rowNameId = '',
    required,
    layout,
    children,
  } = props;

  const isHorizontal = () => {
    return layout==='horizontal';
  };

  return (
    <Row className={style.formRow}>
      <Col className={isHorizontal()?style.formColHeaderHorizontal:style.formColHeader} xs={isHorizontal()?2:12}>
        <Message messageId={rowNameId}/>
        {required &&
        <Message messageId={'indispensable'} className={'aw-form-field-required'}/>
        }
      </Col>
      <Col className={isHorizontal()?style.formColHorizontal:style.formCol} xs={isHorizontal()?10:12}>
        {children}
      </Col>
    </Row>
  )

}

FormRow.propTypes = {
  rowNameId: PropTypes.string,
  required: PropTypes.bool,
  layout: PropTypes.string,
};

export default FormRow;
